module.exports = __webpack_public_path__ + "static/media/usa.123ac360.png";